import { Checkbox } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import TableBodyCell from '../../../../../components/NewCustomTableElements/TableBodyCell'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import { useNewBodyCheckbox } from '../hooks/useNewBodyCheckbox'

type NewBodyCheckboxProps = {
  element: RequestType
  backgroundColor?: string
  data: any
  checkboxStore: any
}

const NewBodyCheckbox: FC<NewBodyCheckboxProps> = ({
  element,
  backgroundColor,
  data,
  checkboxStore,
}) => {
  const { checked, handleClickCheckbox, showCheckbox } = useNewBodyCheckbox(
    element,
    data,
    checkboxStore,
  )

  return (
    <TableBodyCell
      backgroundColor={backgroundColor}
      key={element.created}
      width='40px!important'
      height={'40px!important'}
      propKey='checkbox'
      customPadding='8px'
    >
      {showCheckbox && (
        <Checkbox checked={checked} onClick={handleClickCheckbox} />
      )}
    </TableBodyCell>
  )
}

export default observer(NewBodyCheckbox)
